import { Link } from "react-router-dom";
import { fromNow } from "../Utils";

const Item = ({ item, link }) => {
    const {
        images,
        name,
        price,
        created_at,
        type,
        user,
        shop,
        meta_data,
    } = item;
  
    return (
        <div className="safe-item">
            <Link to={link} state={{ item: item }}>
                <div className="d-flex">
                    <span style={{ textDecoration: "none" }}>
                        <div className="item-img">
                            <img src={images[0]} />
                        </div>
                        <div className="number-img">
                            <i className="fas fa-camera"></i>
                            <span>{images && images.length}</span>
                        </div>
                    </span>
                    <div className="item-info w-100">
                        <div className="d-flex align-items-center justify-content-between">
                            <p>{name}</p>
                            {type === 'safe' ? (
                                <div className="icon">
                                    <img src={type == 'safe' ? shop && shop.logo : ""} alt={shop ? shop.name : ""} />
                                </div>
                            ) : null}
                        </div>
                        <div className="d-flex justify-content-between">

                            {type === 'safe' && (
                                <div className="d-flex safe">
                                    <i className="fas fa-truck"></i>
                                    <span>خرید امن</span>
                                </div>
                            )}

                            {meta_data && meta_data.vip && (
                                <div className="d-flex safe">
                                    <i className="fas fa-badge-check"></i>
                                    <span>ویژه</span>
                                </div>
                            )}
                        </div>
                        <div className={`${type === 'safe' ? "mt-3" : "mt-5"} d-flex justify-content-between`}>
                            <span>{price == 'توافقی' ? price : parseInt(price).toLocaleString() + " تومان "}</span>
                            <span>{fromNow(new Date(created_at))}</span>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    )
}

export default Item;